import { createFileRoute, Navigate } from '@tanstack/react-router';
import { Forbidden } from '@/components/shared/page-states';
import { useCan } from '@/features/auth/session';

/**
 * The root sends the employee to the first page they may open, in the same
 * order as the sidebar. Without any page permission it shows the forbidden
 * state instead of redirecting to a page that would refuse them.
 */
export function DashboardLanding(): React.JSX.Element {
  const canTransfers = useCan('TRANSFER_LIST');
  const canNewTransfer = useCan('TRANSFER_CREATE');
  const canBoxes = useCan('BOX_LIST');
  const canBankAccounts = useCan('BANK_ACCOUNT_LIST');
  const canReports = useCan('REPORT_VIEW');
  const canTiers = useCan('TIER_LIST');
  const canSettings = useCan('SETTINGS_VIEW');
  const canUsers = useCan('USER_LIST');
  const canGroups = useCan('GROUP_LIST');

  if (canTransfers) return <Navigate to="/transfers" replace />;
  if (canNewTransfer) return <Navigate to="/transfers/new" replace />;
  if (canBoxes) return <Navigate to="/boxes" replace />;
  if (canBankAccounts) return <Navigate to="/bank-accounts" replace />;
  if (canReports) return <Navigate to="/reports" search={{ tab: 'summary' }} replace />;
  if (canTiers) return <Navigate to="/settings/tiers" replace />;
  if (canSettings) return <Navigate to="/settings/transfers" replace />;
  if (canUsers) return <Navigate to="/settings/users" replace />;
  if (canGroups) return <Navigate to="/settings/groups" replace />;
  return <Forbidden />;
}

export const Route = createFileRoute('/_app/')({
  component: DashboardLanding,
});
